import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Icommon, IJoinUs } from "../Shared/IJoinUs";
import { JoinUsService } from "../Shared/join-us.service";

@Component({
  selector: 'app-contact-sales',
  templateUrl: './contact-sales.component.html',
  styleUrls: ['./contact-sales.component.scss']
})
export class ContactSalesComponent implements OnInit {
  loader: boolean = false;
  myform: UntypedFormGroup;
  catagory: Icommon[] = [];
  success: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private msg: ToastrService,
    private joinserv: JoinUsService
  ) {}

  ngOnInit(): void {
    this.getAllServiveCategories();

    this.myform = this.fb.group({
      id: [""],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]], // Validators.pattern(regexPatterns.emailPattern)]],//
      phone: ["", [Validators.required]], //Validators.pattern(regexPatterns.mobPattern)]],//
      businessName: ["", Validators.required],
      category: ["", Validators.required], // CAT NAME, ID
      message: [""],
    });
  }

  get firstNameCtrl() {
    return this.myform.get("firstName");
  }
  get lastNameCtrl() {
    return this.myform.get("lastName");
  }
  get emailCtrl() {
    return this.myform.get("email");
  }
  get phoneCtrl() {
    return this.myform.get("phone");
  }
  get businessNameCtrl() {
    return this.myform.get("businessName");
  }
  get categoryCtrl() {
    return this.myform.get("category");
  } //
  get messageCtrl() {
    return this.myform.get("message");
  }



  toggle() {
    console.log('value')
    this.success = true;
    // this.paramValue=value;
    // this.toggleProp = !this.toggleProp;
  }



  onSubmit() {

    if (!this.myform.valid) {
    

      if (
        this.myform.controls["firstName"].invalid ||
        this.myform.controls["lastName"].invalid ||
        this.myform.controls["phone"].invalid ||
        this.myform.controls["businessName"].invalid ||
        this.myform.controls["category"].invalid ||
        this.myform.controls["message"].invalid
      ) {
        this.msg.warning(
          "The data entered into a form needs to be in the right format and certain fields" +
            "need to be filled in order to effectively use the submitted form."
        );
      } else if (this.myform.controls["email"].invalid) {
        this.msg.warning("Email not entered correctly");
      }
      console.log("notvalid");
      return;

    } else {
      console.log("valid");
    }
    if (this.myform.valid) {
      let myObj = {} as IJoinUs;
      myObj.firstName = this.firstNameCtrl.value;
      myObj.lastName = this.lastNameCtrl.value;
      myObj.email = this.emailCtrl.value;
      myObj.phone = this.phoneCtrl.value;
      myObj.businessName = this.businessNameCtrl.value;
      myObj.categoryId = (this.categoryCtrl.value as Icommon).id;
      myObj.categoryName = (this.categoryCtrl.value as Icommon).name;
      myObj.notes = this.messageCtrl.value;
      // myObj.notes = this.messag; //  سبب المشكله
      myObj.key = "FFN07C5F5514F4DDA3CA9F96DE48119EC7EA";

      if (
        !myObj.firstName ||
        !myObj.lastName ||
        !myObj.email ||
        !myObj.phone ||
        !myObj.businessName ||
        !myObj.categoryId
      ) {
        this.msg.warning(
          "The data entered into a form needs to be in the right format and certain fields" +
            "need to be filled in order to effectively use the submitted form."
        );
        return;
      }

      this.loader = true;
      //console.log('NOW CALL SERVER: ', myObj);
      this.joinserv.AddJoinUs(myObj).subscribe(
        (response) => {
          if (response.errorOccured) {
            this.msg.warning(response.errorMessage);
            this.loader = false;
            return;
          }
          console.log(response);
          this.loader = false;
          this.success = true;
          
          // this.msg.success(response.result);
          this.myform.reset();
          Object.keys(this.myform.controls).forEach((key) => {
            this.myform.get(key).setErrors(null);
          });
          //this.msg.success("Your Message Has been Sent Successfully...");
          // this.dialogRef.close(myObj);
        },
        (err: HttpErrorResponse) => {
          this.loader = false;
          // this.loder.stop();
          if (err.status === 400) {
            this.msg.error(err.error);
            console.log("Error");
          } else if (err.status === 503) {
            this.msg.error(err.error);
          } else {
            this.msg.info(
              "Unable To Access Server, Please refresh the page and try again"
            );
          }
        }
      );
    } else {
      this.msg.info("Nothing changed!");
    }
  }
  onSelectCatagory(e: any) {
    this.myform.get("category").setValue(e.value);
  }

  getAllServiveCategories() {
    console.log("in cat");
    this.catagory = [
      {
        id: "ad1dd380-6361-4c12-a04d-aad45c527ce8",
        name: "Schools",
        imageURL: null,
        coverURL: null,
        notes: null,
        value: null,
      },

      {
        id: "f71ffa6b-62d5-4be6-bced-b31594bd966a",
        name: "Nurseries",
        imageURL: null,
        coverURL: null,
        notes: null,
        value: null,
      },

      {
        id: "658ac737-ef6d-4189-9be3-eb414cbe7b77",
        name: "Academic Centers",
        imageURL: null,
        coverURL: null,
        notes: null,
        value: null,
      },

      {
        id: "997ba58b-2b50-44fd-96c5-ab5000a90aa9",
        name: "Institutions",
        imageURL: null,
        coverURL: null,
        notes: null,
        value: null,
      },

      {
        id: "df21944f-0699-4eef-8ea3-abda0050e069",
        name: "Universities",
        imageURL: null,
        coverURL: null,
        notes: null,
        value: null,
      },

      {
        id: "21f04dc4-4324-47ef-872c-aec200c015f5",
        name: "Other",
        imageURL: null,
        coverURL: null,
        notes: null,
        value: null,
      },
    ];
  
  }
}
